import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";
import { useJourneyStaticDetails } from "../../../context";

export default function WizardBody() {
  const { currentStepConfig, goToNextStep } = useStepFlow();
  const { journeySearchData } = useJourneyStaticDetails();
  const { Component, overrideBody } = currentStepConfig;
  const overriddenBody = overrideBody?.({ isLcc:journeySearchData.isLcc, goToNextStep: () => goToNextStep() });
  if (overriddenBody) return overriddenBody;
  if (!Component) return null;
  return <Component />;
}
